import type { ComponentProps, ReactNode } from 'react'
import { Avatar } from '#src/components/core/Avatar/Avatar.tsx'

export interface InboxRowAvatarProps {
  profile: ComponentProps<typeof Avatar>['profile']
  icon?: ReactNode
}

export function InboxRowAvatar({
  profile,
  icon,
}: InboxRowAvatarProps): ReactNode {
  return (
    <div className="relative">
      <Avatar profile={profile} className="size-8 text-sm" />
      {icon}
    </div>
  )
}
